import { Role } from '@/api/types'

export default [
    {
        name: 'actions_calendar',
        path: '/actions',
        props: true,
        meta: { requiredRole: Role.EMPLOYEE, showScrollbar: false, noBackground: false },
        component: () => import(/* webpackChunkName: "tasks_list" */ '../../views/Actions/Calendar.vue'),
    },
]
